import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { candidateEndpoints } from '@/modules/candidates/constants';
import {
  candidateFeedbackQueryKeys,
  candidateJobQueryKeys,
} from '@/modules/candidates/queries/queryKeys';
import type { CandidateJobFeedbackRequestApi } from '@/modules/candidates/types';
import { candidateSubmissionsAwaitingReviewQueryKeys } from '@/modules/hiring-manager/queries/useCandidateSubmissionsAwaitingReviewQuery';
import { invalidateQuery } from '@/utils/queries';

export const useCreateCandidateFeedbackMutation = (
  jobId: string,
  candidateId: string,
) => {
  const queryKey = candidateFeedbackQueryKeys.detail(jobId, candidateId);

  return useMutation({
    mutationFn: async (body: CandidateJobFeedbackRequestApi) => {
      const { data } = await fetchClient.POST(
        candidateEndpoints.candidateFeedback,
        {
          params: {
            path: {
              jobId,
              candidateId,
            },
          },
          body,
        },
      );
      return data;
    },
    onSettled: () => {
      invalidateQuery(queryKey)();
      invalidateQuery(candidateJobQueryKeys.lists(jobId))();
      invalidateQuery(candidateSubmissionsAwaitingReviewQueryKeys.all)();
    },
  });
};
